export const productTypes = {
    GET_ALL_FACTORY_ORDERS_START: "GET_ALL_FACTORY_ORDERS_START",
    GET_ALL_FACTORY_ORDERS_SUCCESS: "GET_ALL_FACTORY_ORDERS_SUCCESS",
    GET_ALL_FACTORY_ORDERS_FAILED: "GET_ALL_FACTORY_ORDERS_FAILED",
    GET_ALL_FACTORY_ORDERS_END: "GET_ALL_FACTORY_ORDERS_END",

    GET_PRINTABLE_FACTORY_ORDERS_START: "GET_PRINTABLE_FACTORY_ORDERS_START",
    GET_PRINTABLE_FACTORY_ORDERS_SUCCESS:
        "GET_PRINTABLE_FACTORY_ORDERS_SUCCESS",
    GET_PRINTABLE_FACTORY_ORDERS_FAILED: "GET_PRINTABLE_FACTORY_ORDERS_FAILED",
    GET_PRINTABLE_FACTORY_ORDERS_END: "GET_PRINTABLE_FACTORY_ORDERS_END",

    GET_ALL_PRODUCT_START: "GET_ALL_PRODUCT_START",
    GET_ALL_PRODUCT_SUCCESS: "GET_ALL_PRODUCT_SUCCESS",
    GET_ALL_PRODUCT_FAILED: "GET_ALL_PRODUCT_FAILED",
    GET_ALL_PRODUCT_END: "GET_ALL_PRODUCT_END",

    GET_ALL_USER_PRODUCT_START: "GET_ALL_USER_PRODUCT_START",
    GET_ALL_USER_PRODUCT_SUCCESS: "GET_ALL_USER_PRODUCT_SUCCESS",
    GET_ALL_USER_PRODUCT_FAILED: "GET_ALL_USER_PRODUCT_FAILED",
    GET_ALL_USER_PRODUCT_END: "GET_ALL_USER_PRODUCT_END",

    CREATE_NEW_PRODUCT_BY_ADMIN_START: "CREATE_NEW_PRODUCT_BY_ADMIN_START",
    CREATE_NEW_PRODUCT_BY_ADMIN_SUCCESS: "CREATE_NEW_PRODUCT_BY_ADMIN_SUCCESS",
    CREATE_NEW_PRODUCT_BY_ADMIN_FAILED: "CREATE_NEW_PRODUCT_BY_ADMIN_FAILED",
    CREATE_NEW_PRODUCT_BY_ADMIN_END: "CREATE_NEW_PRODUCT_BY_ADMIN_END",

    UPDATE_NEW_PRODUCT_BY_ADMIN_START: "UPDATE_NEW_PRODUCT_BY_ADMIN_START",
    UPDATE_PRODUCT_BY_ADMIN_SUCCESS: "UPDATE_PRODUCT_BY_ADMIN_SUCCESS",
    UPDATE_PRODUCT_BY_ADMIN_FAILED: "UPDATE_PRODUCT_BY_ADMIN_FAILED",
    UPDATE_PRODUCT_BY_ADMIN_END: "UPDATE_PRODUCT_BY_ADMIN_END",

    DELETE_PRODUCT_BY_ADMIN_START: "DELETE_PRODUCT_BY_ADMIN_START",
    DELETE_PRODUCT_BY_ADMIN_SUCCESS: "DELETE_PRODUCT_BY_ADMIN_SUCCESS",
    DELETE_PRODUCT_BY_ADMIN_FAILED: "DELETE_PRODUCT_BY_ADMIN_FAILED",
    DELETE_PRODUCT_BY_ADMIN_END: "DELETE_PRODUCT_BY_ADMIN_END",
};
